// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Constants {
	export const DEFAULT_PROJECT_ID = '$$$$$';
}
